import React, { useContext, useEffect, useRef, useState } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Button, MenuItem, TextField, Snackbar, Alert } from '@mui/material';
import CustomTextField from '../../../components/OB/required-text-field';
import CustomDatePicker from '../../../components/OB/required-datepicker';
import { MuiTelInput } from 'mui-tel-input';
import { ConstantAPISContext } from '../../../context/ConstantAPISContext';
import CheckboxGroup from '../../../components/OB/selectDay';
import dayjs from 'dayjs';
import KisiSicilSecim from '../../../components/OB/popups/KisiSicilSecim';
import { safelyParseNumber } from '../../../helpers/MoneyFormat';
import OkulListeAPI from '../../../apis/OB/Get/OkulListeAPI';
import FakulteListeAPI from '../../../apis/OB/Get/FakulteListeAPI';
import StajBasvuruAPI from '../../../apis/OB/SaveApi/StajBasvuru';
import BilgilendirmePopup from '../../../components/OB/popups/BilgilendirmePopUp';
import SessionStorageService from '../../../services/StorageService';
import CustomMuiTelInput from '../../../components/OB/required-muitelinput';
import { toast } from 'react-toastify';
import Recaptcha from "../../../components/Recaptcha";

const validationSchema = Yup.object({
  tcKimlikNo: Yup.string().required('T.C Kimlik No zorunludur.'),
  ad: Yup.string().required('Ad zorunludur.'),
  soyad: Yup.string().required('Soyad zorunludur.'),
  dogumTarihi: Yup.date().nullable().required('Doğum Tarihi zorunludur.'),
  cepTelefonu: Yup.string().required('Cep Telefonu zorunludur.'),
  acikAdres: Yup.string().required('Açık Adres zorunludur.'),
  evTelefonu: Yup.string(),
  okulId: Yup.number().nullable().required('Okul seçimi zorunludur.'),
  fakulteId: Yup.number().nullable().required('Fakülte seçimi zorunludur.'),
  ogrenimYili: Yup.number().nullable().required('Öğrenim Yılı zorunludur.'),
  sgkBaslangicTarihi: Yup.date().nullable().required('SGK Başlama Tarihi zorunludur.'),
  stajBaslamaTarihi: Yup.date().nullable().required('Staj Başlama Tarihi zorunludur.'),
  stajBitisTarihi: Yup.date().nullable().required('Staj Bitiş Tarihi zorunludur.'),
  ibanNo: Yup.string().required('Iban No zorunludur.'),
  pazartesi: Yup.number(),
  sali: Yup.number(),
  carsamba: Yup.number(),
  persembe: Yup.number(),
  cuma: Yup.number(),
  days: Yup.array().test(
    'at-least-one-checked',
    'En az bir gün seçilmelidir.',
    function (values) {
      const { pazartesi, sali, carsamba, persembe, cuma } = this.parent;
      return pazartesi === 1 || sali === 1 || carsamba === 1 || persembe === 1 || cuma === 1;
    }
  ),
});

const StajBasvuru = (props: any) => {

  const recaptchaRef = useRef<any>(null);
  const [recaptchaPassed, setRecaptchaPassed] = useState(false);
  const [recaptchaError, setRecaptchaError] = useState(false);

  const { yilListe } = useContext(ConstantAPISContext);
  const [okulListe, setOkulListe] = useState<any[]>([]);
  const [fakulteListe, setFakulteListe] = useState<any[]>([]);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [popupAciklama, setPopupAciklama] = useState("");
  const [kayitBasarili, setKayitBasarili] = useState(false);
  const user = SessionStorageService.getUserInfo();

  const closePopupSonuc = () => {
    setIsPopupVisible(false);
    setPopupAciklama("");
  };

  useEffect(() => {
    OkulListeAPI.getOkulListe(undefined).then((response) => {
      setOkulListe(response.data);
    }).catch((error) => {
    });
    FakulteListeAPI.getFakulteListe(undefined).then((response) => {
      setFakulteListe(response.data);
    }).catch((error) => {
    });
  }, []);

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [showError, setShowError] = useState(false);

  const handleKimlikSorgulaClick = (tcKimlikNo: string) => {
    if (tcKimlikNo.length < 11) {
      setShowError(true);
      return;
    }
    setIsPopupOpen(true);
  };

  return (
    <div>
      <Snackbar
        open={showError}
        autoHideDuration={6000}
        onClose={() => setShowError(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setShowError(false)} severity="error">
          Lütfen T.C Kimlik No 11 haneli olmalıdır!
        </Alert>
      </Snackbar>
      <Formik
        initialValues={{
          basvuruTuruId: 14,
          tcKimlikNo: user?user.tcKimlikNo:props.tcKimlikNo?props.tcKimlikNo:"",
          ad: user?user.adi:"",
          soyad: user?user.soyadi:"",
          dogumTarihi: null,
          acikAdres: user?user.adres:"",
          cepTelefonu: "",
          evTelefonu: "",
          okulId: null,
          fakulteId: null,
          ogrenimYili: null,
          stajBitisTarihi: null,
          stajBaslamaTarihi: null,
          sgkBaslangicTarihi: null,
          ibanNo: "",
          pazartesi: 0,
          sali: 0,
          carsamba: 0,
          persembe: 0,
          cuma: 0,
        }}
        validateOnMount={true}
        validationSchema={validationSchema}
        onSubmit={async (values: any, { resetForm }) => {

          // reCAPTCHA’yı tetikle
          const token = await recaptchaRef.current?.handleSubmit();
          if (!token) {
            toast.error("reCAPTCHA doğrulanamadı, lütfen tekrar deneyiniz.");
            return;
          }

          const transformedValues = {
            ...values,
            tcKimlikNo: safelyParseNumber(values.tcKimlikNo),
            okulId: safelyParseNumber(values.okulId),
            fakulteId: safelyParseNumber(values.fakulteId),
            ogrenimYili: values.ogrenimYili.toString(),
            pazartesi: safelyParseNumber(values.pazartesi),
            sali: safelyParseNumber(values.sali),
            carsamba: safelyParseNumber(values.carsamba),
            persembe: safelyParseNumber(values.persembe),
            cuma: safelyParseNumber(values.cuma),
            cepTelefonu: values.cepTelefonu.replace("+90", "").replace(/\s/g, ""),
            evTelefonu: values.evTelefonu != "" ? values.cepTelefonu.replace("+90", "").replace(/\s/g, "") : "",
            captchaToken: token
          };
          StajBasvuruAPI.saveStajBasvuruSave(transformedValues)
            .then((res) => {
              if (res.data.sonuc === 0) {
                let basvuruNo = res.data.basvuruNo;
                setPopupAciklama(
                  "İşleminiz başarıyla gerçekleştirildi. Başvuru Numaranız: " +
                  basvuruNo
                );
                resetForm();
                setKayitBasarili(true);
              } else {
                setPopupAciklama(res.data.sonucAciklama);
              }
            })
            .catch((err) => {
              setPopupAciklama(
                "İşleminizi gerçekleştirirken bir hata oluştu. Lütfen tekrar deneyiniz (API error)."
              );
            })
            .finally(() => {
              setIsPopupVisible(true);
              recaptchaRef.current?.reset();
            });
        }}
      >
        {(formikProps) => {
          // eslint-disable-next-line react-hooks/rules-of-hooks
          const focusFirstErrorField = () => {
            const errorKeys = Object.keys(formikProps.errors);
            if (errorKeys.length > 0) {
              const firstErrorKey = errorKeys[0];
              const element = document.querySelector(`[name="${firstErrorKey}"]`);
              if (element) {
                (element as HTMLElement).focus();
              }
            }
          };
          // eslint-disable-next-line react-hooks/rules-of-hooks
          const showToastIfErrorsExist = () => {
            if (Object.keys(formikProps.errors).length > 0) {
              toast.error("Lütfen zorunlu alanları doldurun!");
              focusFirstErrorField();
            }
          };
          // eslint-disable-next-line react-hooks/rules-of-hooks
          useEffect(() => {
            if (Object.keys(formikProps.errors).length > 0) {
              focusFirstErrorField();
            }
          }, [formikProps.errors]);

          const isFormFilled = selectedItem !== null;
          return (
            <Form>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <div className="card shadow-none border w-100">
                    <div className="card-body">
                      <div className="row">
                        <h5>Kimlik Bilgileri</h5>
                        <hr className="my-3" />
                        <div className="col-md-6 mb-3">
                          <CustomTextField
                            fullWidth
                            size="small"

                            label="T.C Kimlik No *"
                            error={
                              formikProps.errors.tcKimlikNo &&
                                formikProps.touched.tcKimlikNo
                                ? true
                                : false
                            }
                            value={formikProps.values.tcKimlikNo}
                            onChange={(e: any) =>
                              formikProps.setFieldValue("tcKimlikNo", e.target.value.match(/^[0-9]+$/) ? e.target.value.substring(0, 11) : "")
                            }
                            variant="outlined"
                            disabled={isFormFilled}
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <CustomTextField
                            fullWidth
                            size="small"
                            label="Ad *"
                            error={
                              formikProps.errors.ad && formikProps.touched.ad
                                ? true
                                : false
                            }
                            {...formikProps.getFieldProps("ad")}
                            variant="outlined"
                            disabled={isFormFilled}
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <CustomDatePicker
                            name="dogumTarihi"
                            slotProps={{
                              textField: {
                                size: "small",
                                fullWidth: true,
                                error:
                                  formikProps.errors.dogumTarihi &&
                                    formikProps.touched.dogumTarihi
                                    ? true
                                    : false,
                              },
                            }}
                            label="Doğum Tarihi *"
                            value={formikProps.values.dogumTarihi}
                            onChange={(value: any) =>
                              formikProps.setFieldValue("dogumTarihi", value)
                            }
                            disabled={isFormFilled}
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <CustomTextField
                            fullWidth
                            size="small"
                            label="Soyad *"
                            error={
                              formikProps.errors.soyad &&
                                formikProps.touched.soyad
                                ? true
                                : false
                            }
                            {...formikProps.getFieldProps("soyad")}
                            variant="outlined"
                            disabled={isFormFilled}
                          />
                        </div>
                        <div className="col-12 mb-3">
                          <Button
                            fullWidth
                            onClick={() => handleKimlikSorgulaClick(formikProps.values.tcKimlikNo)}
                          >
                            Kimlik Sorgula
                          </Button>
                        </div>
                        <h5>İletişim Bilgileri</h5>
                        <hr className="my-3" />
                        <div className="col-lg-6 mb-3">
                          <CustomMuiTelInput
                            name="cepTelefonu"
                            fullWidth
                            defaultCountry="TR"
                            onlyCountries={["TR"]}
                            className="mb-3"
                            disabled={selectedItem !== null && selectedItem.cepTelefonu !== null}
                            size="small"
                            label="Cep Telefonu *"
                            value={formikProps.values.cepTelefonu}
                            error={
                              formikProps.errors.cepTelefonu &&
                                formikProps.touched.cepTelefonu
                                ? true
                                : false
                            }
                            inputProps={{ maxLength: 17 }}

                            onChange={(value: any) => {
                              const prefix = "+90";
                              if (!value.startsWith(prefix)) {
                                value = prefix + value.replace(/^\+90/, "");
                              }
                              formikProps.setFieldValue("cepTelefonu", value);
                            }}
                            variant="outlined"
                          />
                          <MuiTelInput
                            fullWidth
                            defaultCountry="TR"
                            onlyCountries={["TR"]}
                            size="small"
                            label="Sabit Telefonu"
                            value={formikProps.values.evTelefonu}
                            inputProps={{ maxLength: 17 }}
                            error={
                              formikProps.errors.evTelefonu &&
                                formikProps.touched.evTelefonu
                                ? true
                                : false
                            }
                            onChange={(value: any) => {
                              const prefix = "+90";
                              if (!value.startsWith(prefix)) {
                                value = prefix + value.replace(/^\+90/, "");
                              }
                              formikProps.setFieldValue("evTelefonu", value);
                            }}
                            variant="outlined"
                          />
                        </div>
                        <div className="col-lg-6 mb-3">
                          <CustomTextField
                            id="outlined-multiline-flexible"
                            label="Açık Adres *"
                            error={
                              formikProps.errors.acikAdres &&
                                formikProps.touched.acikAdres
                                ? true
                                : false
                            }
                            {...formikProps.getFieldProps("acikAdres")}
                            rows={2.8}
                            fullWidth
                            multiline
                            maxRows={4}
                          />
                        </div>
                        <h5>Eğitim Bilgileri</h5>
                        <hr className="my-3" />
                        <div className="col-md-6 mb-3">
                          <CustomTextField
                            name="okulId"
                            fullWidth
                            select
                            label="Okul *"
                            size="small"
                            error={
                              formikProps.errors.okulId &&
                                formikProps.touched.okulId
                                ? true
                                : false
                            }
                            value={formikProps.values.okulId}
                            onChange={(value: any) => {
                              formikProps.setFieldValue(
                                "okulId",
                                Number(value.target.value)
                              );
                            }}
                          >
                            <MenuItem selected value={null as any}>
                              {"Seçiniz.."}
                            </MenuItem>
                            {okulListe.map((option: any) => (
                              <MenuItem key={option.okulId} value={option.okulId}>
                                {option.okulAdi}
                              </MenuItem>
                            ))}
                          </CustomTextField>
                        </div>
                        <div className="col-md-6 mb-3">
                          <CustomTextField
                            name="fakulteId"
                            fullWidth
                            select
                            label="Fakülte *"
                            size="small"
                            error={
                              formikProps.errors.fakulteId &&
                                formikProps.touched.fakulteId
                                ? true
                                : false
                            }
                            value={formikProps.values.fakulteId}
                            onChange={(value: any) => {
                              formikProps.setFieldValue(
                                "fakulteId",
                                Number(value.target.value)
                              );
                            }}
                          >
                            <MenuItem selected value={null as any}>
                              {"Seçiniz.."}
                            </MenuItem>
                            {fakulteListe.map((option: any) => (
                              <MenuItem key={option.fakulteId} value={option.fakulteId}>
                                {option.fakulteAdi}
                              </MenuItem>
                            ))}
                          </CustomTextField>
                        </div>
                        <div className="col-md-6 mb-3">
                          <CustomTextField
                            name="ogrenimYili"
                            fullWidth
                            select
                            label="Öğrenim Yılı *"
                            size="small"
                            error={
                              formikProps.errors.ogrenimYili &&
                                formikProps.touched.ogrenimYili
                                ? true
                                : false
                            }
                            value={formikProps.values.ogrenimYili}
                            onChange={(value: any) => {
                              formikProps.setFieldValue('ogrenimYili', Number(value.target.value));
                            }}
                          >
                            <MenuItem selected value={null as any}>
                              {'Seçiniz..'}
                            </MenuItem>
                            {yilListe.map((option: any) => (
                              <MenuItem key={option.yili} value={option.yili}>
                                {option.yili}
                              </MenuItem>
                            ))}
                          </CustomTextField>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="card shadow-none border w-100">
                    <div className="card-body">
                      <div className="row">
                        <h5>Staj Bilgileri</h5>
                        <hr className="my-3" />
                        <div className="col-md-6 mb-3">
                          <CustomDatePicker
                            name="sgkBaslangicTarihi"
                            slotProps={{
                              textField: {
                                size: "small",
                                fullWidth: true,
                                error:
                                  formikProps.errors.sgkBaslangicTarihi &&
                                    formikProps.touched.sgkBaslangicTarihi
                                    ? true
                                    : false,
                              },
                            }}
                            label="SGK Başlama Tarihi *"
                            value={formikProps.values.sgkBaslangicTarihi}
                            onChange={(value: any) =>
                              formikProps.setFieldValue('sgkBaslangicTarihi', value)
                            }
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <CustomDatePicker
                            name="stajBaslamaTarihi"
                            slotProps={{
                              textField: {
                                size: "small",
                                fullWidth: true,
                                error:
                                  formikProps.errors.stajBaslamaTarihi &&
                                    formikProps.touched.stajBaslamaTarihi
                                    ? true
                                    : false,
                              },
                            }}
                            label="Staj Başlama Tarihi *"
                            value={formikProps.values.stajBaslamaTarihi}
                            onChange={(value: any) =>
                              formikProps.setFieldValue('stajBaslamaTarihi', value)
                            }
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <CustomDatePicker
                            name="stajBitisTarihi"
                            slotProps={{
                              textField: {
                                size: "small",
                                fullWidth: true,
                                error:
                                  formikProps.errors.stajBitisTarihi &&
                                    formikProps.touched.stajBitisTarihi
                                    ? true
                                    : false,
                              },
                            }}
                            label="Staj Bitiş Tarihi *"
                            value={formikProps.values.stajBitisTarihi}
                            onChange={(value: any) =>
                              formikProps.setFieldValue('stajBitisTarihi', value)
                            }
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <CustomTextField
                            name="ibanNo"
                            fullWidth
                            className="mb-3"
                            size="small"
                            label="Iban No *"
                            error={
                              formikProps.errors.ibanNo &&
                                formikProps.touched.ibanNo
                                ? true
                                : false
                            }
                            value={formikProps.values.ibanNo}
                            onChange={(e: any) =>
                              formikProps.setFieldValue('ibanNo', e.target.value.match(/^[0-9]+$/) ? e.target.value.substring(0, 26) : '')
                            }
                            variant="outlined"
                          />
                        </div>
                        <h5>Staj Günleri</h5>
                        <hr className="my-3" />
                        <div className="col-12">
                          <CheckboxGroup formik={formikProps} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex align-self-strech justify-content-end">
                <Recaptcha
                  ref={recaptchaRef}
                  changeHandleRecaptcha={setRecaptchaPassed}
                />
                <Button onClick={() => showToastIfErrorsExist()} type="submit">Gönder</Button>
              </div>
              <KisiSicilSecim
                isOpen={isPopupOpen}
                setIsOpen={setIsPopupOpen}
                setItem={(item: any) => {
                  setSelectedItem(item);
                  formikProps.setFieldValue('ad', item.adi);
                  formikProps.setFieldValue('soyad', item.soyadi);
                  formikProps.setFieldValue('dogumTarihi', dayjs(item.dogumTarihi));
                  formikProps.setFieldValue('tcKimlikNo', item.tcKimlikNo);
                  formikProps.setFieldValue('acikAdres', item.acikAdres);
                  formikProps.setFieldValue('cepTelefonu', "+9"+item.cepTelefonu);
                }}
                tcNo={formikProps.values.tcKimlikNo}
              />
              {isPopupVisible ? (
                <BilgilendirmePopup
                  basvuruTuruId={formikProps.values.basvuruTuruId}
                  isSorunBildirPopup={!kayitBasarili}
                  closePopup={closePopupSonuc}
                  open={isPopupVisible}
                  editDescription={popupAciklama}
                />
              ) : null}
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default StajBasvuru;

